export default "__VITE_PUBLIC_ASSET__41af07f3__"